import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// Per-app CPU/RAM utilisation for Platform > Resources, for one civil day.
// `date` is 'YYYY-MM-DD' (omit for today). Polled every 60s so today's view
// stays live while the tab is open.
export function useResources(date) {
  return useQuery({
    queryKey: ['platform', 'resources', date || 'today'],
    queryFn: async () => {
      const { data } = await api.get(`/api/platform/resources${date ? `?date=${date}` : ''}`);
      return data;
    },
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    keepPreviousData: true,
  });
}
